// Dónde entró cada pago, cómo se pagó y quién lo recibió; lo comparten las pantallas del crédito.
import type { LoanPaymentListItem } from '@/api/services/loan-credit';
import { wireLookup } from '@/lib/wireLookup';
import {
    CHARGE_KIND_LABEL,
    collectionMechanismLabelOf,
    unknownWireLabel,
} from '../installments/payments';

/** Cartera del cliente: así se nombra el origen de los pagos del motor. */
export const WALLET_ORIGIN_LABEL = 'Cartera PagoConFiado';
const STORE_FALLBACK_LABEL = 'Tienda';
const NO_METHOD_LABEL = '—';

type InStoreMethod = NonNullable<LoanPaymentListItem['inStoreMethod']>;

export const IN_STORE_METHOD_LABEL: Record<InStoreMethod, string> = {
    CASH: 'Efectivo',
    CARD: 'Tarjeta',
    WIRE: 'SPEI',
};

/** Dónde entró el pago, cómo se pagó y quién lo recibió (null si no lo recibió una persona). */
export interface PaymentOriginFacts {
    where: string;
    how: string;
    who: string | null;
}

type PaymentOriginSource = Pick<
    LoanPaymentListItem,
    'origin' | 'mechanism' | 'inStoreMethod' | 'collectedAtStore' | 'collectedBySeller'
>;

/** Sin `origin` (filas viejas) el pago es del motor: sale de la cartera. */
export function paymentOriginFactsOf(payment: PaymentOriginSource): PaymentOriginFacts {
    if (payment.origin === 'IN_STORE') {
        const method = payment.inStoreMethod;
        return {
            where: payment.collectedAtStore?.name ?? STORE_FALLBACK_LABEL,
            how: method
                ? (wireLookup(IN_STORE_METHOD_LABEL, method) ?? unknownWireLabel(method))
                : NO_METHOD_LABEL,
            who: payment.collectedBySeller?.name ?? null,
        };
    }
    return {
        where: WALLET_ORIGIN_LABEL,
        how: collectionMechanismLabelOf(payment.mechanism),
        who: null,
    };
}

/** «Cuota», «Adelanto», «Abono a capital» o «Liquidación»; sin tipo es cuota (filas viejas). */
export function paymentChargeKindLabelOf(chargeKind: string | undefined): string {
    if (chargeKind === undefined) return CHARGE_KIND_LABEL.INSTALLMENT;
    return wireLookup(CHARGE_KIND_LABEL, chargeKind) ?? unknownWireLabel(chargeKind);
}
